import React from "react";
import PropTypes from "prop-types";
import { CardMedia, makeStyles } from "@material-ui/core";
import useVideoThumbController from "../../../hooks/useVideoThumbController.js";

const useStyles = makeStyles(() => ({
  root: {
    backgroundSize: "contain",
  },
  cardMedia: {
    height: 200,
  },
}));

/**
 * @param {TheNews} news
 * @returns {*}
 * @constructor
 */
const MyCardMediaNews = ({ news }) => {
  const classes = useStyles();
  const { src } = useVideoThumbController(news.video);

  if (!news) return null;

  return <CardMedia classes={{ root: classes.root }} className={classes.cardMedia} image={news.image?.url || src} />;
};

MyCardMediaNews.propTypes = {
  news: PropTypes.object.isRequired,
};

export default MyCardMediaNews;
